module.exports = __webpack_public_path__ + "img/img30.b53bf204.png";